<template>
  <div class="col-lg-12">
    <div class="card card-body card-panel-box border-0">
      <div class="row d-flex justify-content-start">
        <h2 style="font-size: 1.2vw !important;">مدارک مرتبط با فرآیند</h2>
      </div>

      <div class="table-responsive">
        <p v-show="allItems.length===0" style="font-size: 1vw">  مدارک مرتبط با فرآیند وجود ندارد    </p>
        <table class="table table-striped" v-show="allItems.length!==0">
          <thead>
          <tr>
            <th style="width: 1vw;">ردیف</th>
            <th>نام مدرک</th>
            <th>کد مدرک</th>
            <th>نوع مدرک</th>
            <th>محل بایگانی</th>
            <th>مدت زمان بایگانی</th>
            <th>فایل    </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in allItems">
            <td scope="row">{{index+1}}</td>
            <td>{{item['name']}}</td>
            <td>{{item['code']}}</td>
            <td>{{item['type']}}</td>
            <td>{{item['location']}}</td>
            <td>{{item['time']}}</td>
            <td>
             <center> <a
                 target="_blank"
                 :href="item['file']"
                 class="btn btn-primary btn-submit-1"
                 download>دانلود</a>

             </center>
            </td>


          </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
<!--  ********************************************  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 15%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(item_id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="error"
       style="z-index: 999999999999999999999999999999999999999999999; top: 15%;">
    <div>
      <p>   خطا  </p>
      <p @click="error=!error">❌</p>
    </div>
    <div>
      {{errorMessage}}



      <button @click="error=!error">بازگشت</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Documents",
  props: ['id_route'],
  data(){
    return{
      allItems: [],
      name: '',
      code: '',
      type: '',
      location: '',
      time: '',
      file: '',
      deleteModal: false,
      updateAction: false,
      item_id: '',
      error: false,
      errorMessage: '',
    }
  },
  methods:{
    deleteItemForm(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/document_process/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.fetchItems()
            this.deleteModal=false



          })
          .catch();

    },
    editMethod(id){
      this.item_id=id

      this.updateAction=true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/document_process/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const data = response.item
            if (data){
              this.name=data.name
              this.code=data.code
              this.type=data.type
              this.location=data.location
              this.time=data.time
            }




          })
          .catch();

    },
    update(id){
      const fileInput = document.getElementById("file");

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      formdata.append('processes_id', this.id_route)
      formdata.append('name', this.name)
      formdata.append('code', this.code)
      formdata.append('type', this.type)
      formdata.append('location', this.location)
      formdata.append('time', this.time)
      if (fileInput.files[0]){
      formdata.append('file', fileInput.files[0])

      }


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/document_process/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              this.error=true

              this.errorMessage=response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return
            }
            this.name=''
            this.code=''
            this.type=''
            this.location=''
            this.time=''
            fileInput.value=''
            this.fetchItems()
            this.updateAction=false


          })
          .catch();

    },
    deleteItemModal(id){
      this.deleteModal=true
      this.item_id=id

    },
    addItem(){
      const fileInput = document.getElementById("file");

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
       formdata.append('processes_id', this.id_route)
      formdata.append('name', this.name)
      formdata.append('code', this.code)
      formdata.append('type', this.type)
      formdata.append('location', this.location)
      formdata.append('time', this.time)
      formdata.append('file', fileInput.files[0])


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/document_process/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              this.error=true

              this.errorMessage=response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return

            }
            this.name=''
            this.code=''
            this.type=''
            this.location=''
            this.time=''
            fileInput.value=''
            this.fetchItems()

          })
          .catch();


    },
    fetchItems(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/document_process/show/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.allItems.length=0
            response.items.forEach((ele)=>{
              this.allItems.push(ele)
            })


          })
          .catch();
    }
  },
  mounted() {
    this.fetchItems()
  }
}
</script>

<style scoped>
.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: #D0E9FA57;
  color: var(--bs-table-striped-color);
}
</style>